import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	zeroResultsTitle: {
		id: 'company-hub.cards-extension.smart-card.no-results-title',
		defaultMessage: 'Nothing here yet. Check back soon.',
		description:
			'Placeholder title that is displayed in Smart Card when there are no results given the current filters',
	},
});
